export const CNPJ_DIGITS_LENGTH = 14

export const CNPJ_FORMATTED_LENGTH = 18

export const CPF_DIGITS_LENGTH = 11

export const normalizeCpf = (value: string) => value.replace(/\D/g, "").slice(0, CPF_DIGITS_LENGTH)

export const isValidCpf = (value: string) => {
  const cpf = normalizeCpf(value)

  if (cpf.length !== CPF_DIGITS_LENGTH || /^(\d)\1+$/.test(cpf)) {
    return false
  }

  const calculateDigit = (digits: string, initialWeight: number) => {
    const sum = [...digits].reduce(
      (total, digit, index) => total + Number(digit) * (initialWeight - index),
      0,
    )
    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  return Number(cpf[9]) === calculateDigit(cpf.slice(0, 9), 10)
    && Number(cpf[10]) === calculateDigit(cpf.slice(0, 10), 11)
}

export const normalizeCnpj = (value: string) => value.replace(/\D/g, "").slice(0, CNPJ_DIGITS_LENGTH)

export const isValidCnpj = (value: string) => {
  const cnpj = normalizeCnpj(value)

  if (cnpj.length !== CNPJ_DIGITS_LENGTH || /^(\d)\1+$/.test(cnpj)) {
    return false
  }

  const calculateDigit = (digits: string, weights: number[]) => {
    const sum = weights.reduce((total, weight, index) => total + Number(digits[index]) * weight, 0)
    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  const firstDigit = calculateDigit(cnpj, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  const secondDigit = calculateDigit(cnpj, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  return Number(cnpj[12]) === firstDigit && Number(cnpj[13]) === secondDigit
}

export const formatCnpj = (value: string) => {
  const digitsOnly = normalizeCnpj(value)

  return digitsOnly
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
}

export const normalizeZipCode = (value: string) => value.replace(/\D/g, "").slice(0, 8)

export const formatZipCode = (value: string) => normalizeZipCode(value).replace(/^(\d{5})(\d)/, "$1-$2")
